import React, { useState } from 'react';
import { reduxForm } from 'redux-form';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { SaveButton } from '../../../../itrust_common/components/others';
import { Input, Textarea } from '../../../../itrust_common/components/form';
import { dateFormat } from '../../../../itrust_common/components/HelperFunctions'
import DateFormatView from '../../../../itrust_common/components/others/DateFormatView';

let DocumentForm = props => {
  const { handleSubmit, saving, handlePatientDocumentEdit, patientDocument, patientDocumentEditing } = props;

  const [nameEditing, setNameEditing] = useState(false);

  return (
    <form onSubmit={handleSubmit}>
      <div className="row mx-0 my-5">
        {patientDocument && patientDocument.document_attributes &&
          <>

            <div className="col-4 px-6 py-3 text-muted"> Name </div>
            <div className="col-8 px-6 py-3">
              {nameEditing === false ?
                <div className="d-flex flex-row align-items-top justify-content-between">
                  <span>{patientDocument.document_attributes.filename}</span>
                  <i className="la la-pencil text-muted" onClick={() => setNameEditing(true)}></i>
                </div>
                :
                <div className="row">
                  <Field name="document_attributes.filename" component={Input} className="form-control" wrapperClasses="col-12 " />
                  <div className="col-12">
                    <SaveButton buttonClasses="btn-sm float-right my-4" saving={saving} />
                  </div>
                </div>
              }
            </div>
            <div className="col-4 px-6 py-3 text-muted"> Type </div>
            <div className="col-8 px-6 py-3"> {patientDocument.document_attributes.content_type} </div>
            <div className="col-4 px-6 py-3 text-muted"> Size </div>
            <div className="col-8 px-6 py-3">{`${(patientDocument.document_attributes.byte_size / 1024).toFixed(2)} KB `}</div>
          </>
        }
        <div className="col-4 px-6 py-3 text-muted"> Tag </div>
        <div className="col-8 px-6 py-3">
          {patientDocument.tags_attributes &&
            patientDocument.tags_attributes.map(tag =>
              <span className="pointer badge badge-pill bg-light m-3 d-inline-flex align-items-center ">{tag.name}</span>
            )
          }
        </div>
        <div className="col-4 px-6 py-3 text-muted"> Upload Date </div>
        <div className="col-8 px-6 py-3">
          <DateFormatView date={patientDocument.upload_date} />
        </div>
        <div className="col-4 px-6 py-3 text-muted"> Description </div>
        <div className="col-8 px-6 py-3">
          {patientDocumentEditing === false ?
            <div className="d-flex flex-row align-items-top justify-content-between">
              <span>{patientDocument.description}</span>
              <i className="la la-pencil text-muted" onClick={handlePatientDocumentEdit}></i>
            </div>
            :
            <div className="row">
              <Field name="description" component={Textarea} className="form-control" wrapperClasses="col-12 " />
              <div className="col-12">
                <SaveButton buttonClasses="btn-sm float-right my-4" saving={saving} />
              </div>
            </div>
          }
        </div>
      </div>
    </form>
  )
}

DocumentForm = reduxForm({
  form: 'documentForm',
  enableReinitialize: true
})(DocumentForm)

DocumentForm = connect(state => {
  const { patientDocument, patientDocument: { patient_document } } = state
  return {
    patientDocument: patient_document,
    patientDocumentEditing: patientDocument.editing,
    initialValues: {
      document_attributes: patient_document.document_attributes,
      id: patient_document.id,
      description: patient_document.description
    }
  }
})(DocumentForm)
export default DocumentForm;